import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translations
const resources = {
  en: {
    translation: {
     "menu": {
    "open": "Open menu",
    "close": "Close menu"
  },
  "nav": {
    "home": "HOME",
    "projects": "PROJECTS",
    "services": "SERVICES",
    "about": "ABOUT US"
  },

/////////////////////////////////////////////

 "slides": [
    {
      "title": "Legacy",
      "description": "We build more than structures — we build legacies. Every project we complete is a promise of durability, beauty, and purpose, designed to stand tall today and inspire tomorrow."
    },
    {
      "title": "Excellence",
      "description": "Quality is never a compromise — it’s our foundation. From concept to completion, every step is driven by precision, craftsmanship, and a relentless commitment to exceeding expectations."
    },
    {
      "title": "Innovation",
      "description": "In a rapidly evolving world, staying ahead means building smarter. We integrate modern technology and intelligent planning to deliver construction solutions that are efficient, scalable, and future-ready."
    },
    {
      "title": "Vision",
      "description": "We don’t just build structures — we bring future-focused visions to life. With innovative designs, cutting-edge materials, and sustainable practices, we turn ideas into landmarks that last for generations."
    }
  ],
  "group": "Construction Group",
/////////////////////////////////////////////////////////////////////




  "about": {
    "alt": "About Our Team",
    "title": "Luluat Al Omran Real Estate Development — Rooted in Legacy, Built for the Future",
    "intro": "Luluat Al Omran is the specialized real estate arm of Al Mansouria General Contracting Company, a renowned Saudi firm with over 40 years of experience.",
    "detail1": "Al Mansouria has executed more than 750 projects across the Kingdom, spanning healthcare facilities, educational institutions, government buildings, commercial complexes, and more.",
    "detail2": "Leveraging this strong foundation, Luluat Al Omran was established to lead the way in modern, innovative, and sustainable real estate development, addressing the evolving needs of the Saudi market.",
    "detail3": "Today: Luluat Al Omran continues to shape integrated urban communities, building on the legacy of Al Mansouria while delivering innovative, high-value real estate solutions that enhance quality of life and offer solid returns.",
    "readMore": "Read More",
     "showMore": "Show More",
    "showLess": "Show Less",
    "readLess": "Read Less"
  },

//////////////////////////////////////////////

 "services": {
    "title": "Our Services",
    "learnMore": "Learn More",
    "development": {
      "title": "Real Estate Development",
      "description": "Comprehensive real estate development to create sustainable, innovative properties."
    },
    "management": {
      "title": "Real Estate Management & Leasing",
      "description": "Efficient property management and leasing services to maximize asset value."
    },
    "construction": {
      "title": "Construction Management",
      "description": "Expert oversight of construction projects ensuring quality and timely delivery."
    }
  },

  //////////////////////////////////////////////////////////
   contactUs: "Contact Us",
        address: "Address",
        email: "Email",
        phone: "Phone",
        addressContent: "Luluat Al Omran Real Estate Company Al Murabba District, Riyadh, Kingdom of Saudi Arabia",
        emailAddress: "amer.alrejaye@luluatalomran.com",
        phoneNumbers: "+966 55 547 3463 \n +966 11 488 7491",
        googleMapAlt: "Google Map",
/////////////////////////////////////////////////////////
 followUs: "Follow Us",
    visionAlt: "Vision 2030 Logo",
    copyright:
      "© {{year}} Luluat Al Omran Real Estate Company\nAll rights reserved.",

///////////////////////////////////
 heroTitleLine1: "Build Tomorrow",
    heroTitleLine2: "Live Today",
    ourServices: "Our services",
    stats: {
      districts: "Districts Covered",
      projects: "Under development Projects",
      units: "Under development Units"
    },
    ////////////////////////////////////////////////////////////////////


"projects": {
    "title": "My Projects",
    "area": "Area",
    "location": "Location",
    "projectsList": [
      {
        "name": "LUALUAH 3",
        "description": "Under Development",
        "area": "12,600 m²",
        "location": "ALMALAZ"
      },
      {
        "name": "LUALUAH 2",
        "description": "Under Development",
        "area": "15,000 m²",
        "location": "AL MURABBA"
      },
      {
        "name": "LUALUAH 1",
        "description": "Under Development",
        "area": "13,000 m²",
        "location": "AL MURABBA"
      },
      {
        "name": "LUALUAH 4",
        "description": "Under Development",
        "area": "81,000 m²",
        "location": "AL MURABBA"
      },
      {
        "name": "LUALUAT ALAARID",
        "description": "Under Development",
        "area": "135,450 m²",
        "location": "ALAARID"
      },
      {
        "name": "LUALUAH 5",
        "description": "A modern city apartment with stunning views.",
        "area": "",
        "location": "KING FAHAD ROAD"
      },
      {
        "name": "LUALUAH 6",
        "description": "A modern city apartment with stunning views.",
        "area": "",
        "location": "KING FAHAD ROAD"
      }
    ]
  },
////////////////////////////////////
"services1": {
    "realEstate": {
      "title": "Real Estate Development",
      "description": "Innovative, sustainable developments that shape the future of real estate. We build communities, not just structures."
    },
    "propertyManagement": {
      "title": "Property Management & Leasing",
      "description": "Maximize your ROI with expert leasing and full-service property management. Trusted by clients for decades."
    },
    "construction": {
      "title": "Construction Management",
      "description": "On-time, on-budget, and built with precision. Our construction experts oversee every detail from planning to delivery."
    }
  },
  //////////////////////////////////////////////////
  "history": {
    "title": "HISTORY",
    "subtitle": "LULUAT AL OMRAN REAL ESTATE DEVELOPMENT – ROOTED IN LEGACY, BUILT FOR THE FUTURE.",
    "paragraph1": "Luluat Al Omran is the specialized real estate arm of Al Mansouria General Contracting Company, a renowned Saudi firm with over 40 years of experience. Al Mansouria has executed more than 750 projects across the Kingdom, spanning healthcare facilities, educational institutions, government buildings, commercial complexes, and more.",
    "paragraph2": "Leveraging this strong foundation, Luluat Al Omran was established to lead the way in modern, innovative, and sustainable real estate development, addressing the evolving needs of the Saudi market."
  },
  "milestones": {
    "title": "Milestones",
    "alMansouriyah": "AL-MANSOURIYAH GENERAL CONTRACTING CO. LTD.",
    "industrial": "INDUSTRIAL",
    "turath": "TURATH",
    "realEstateManagement": "REAL ESTATE MANAGEMENT",
    "medicalOffice": "MEDICAL OFFICE",
    "medicalEngineering": "MEDICAL ENGINEERING",
    "raeal": "RAEEL",
    "luluatAlOmran": "LULUAT AL OMRAN REAL ESTATE DEVELOPMENT COMPANY"
  },
  "today": {
    "title": "Today:",
    "description": "Luluat Al Omran continues to shape integrated urban communities, building on the legacy of Al Mansouria while delivering innovative, high-value real estate solutions that enhance quality of life and offer solid returns."
  },

////////////////////////////
"hero": {
    "title": "Building Dreams, Creating Landmarks",
    "subtitle": "Your Future Begins Here",
    "button": "Explore Projects"
  },




  //////////////////////////////////
"team": {
    "heading": "MEMBER of THE BOARD OF DIRECTORS",
    "members": [
      {
        "name": "ENG. SULAIMAN AL.REJAYAE",
        "role": "Board Chairman"
      },
      {
        "name": "MR. AMER AL.REJAYAE",
        "role": "Vice Chairman & CEO"
      },
      {
        "name": "OMER AL-JASSEM",
        "role": "Board Member"
      },
      {
        "name": "MOHAMMED BIN MALIK AL-AHMED",
        "role": "Board Member"
      },
      {
        "name": "ABDULSALAM ALI AL-AJLAN",
        "role": "Board Member"
      }
    ]
  },

/////////////////////////////
"partnerSlider": {
    "heading": "SUCCESS PARTNERS"
  },

///////////////////////////////////////
 "ourProjects": "Our Projects",
  "seeMore": "See More",
  "seeAll": "See All",
  
  "topics": {
    "underDevelopment": "Under Development",
    "futureProject": "Future Project"
  },

  "projects1": {
    "lualuah3": {
      "title": "LUALUAH 3",
      "projectDescription": "A project designed to meet modern needs.",
      "detailTitle": "LUALUAH 3",
      "detailDescription": "Located in Almalaz district, designed for modern needs."
    },
    "lualuah2": {
      "title": "LUALUAH 2",
      "projectDescription": "A premium project in Al Murabba district.",
      "detailTitle": "LUALUAH 2",
      "detailDescription": "A premium project in Al Murabba district."
    },
    "lualuah1": {
      "title": "LUALUAH 1",
      "projectDescription": "Situated in Al Murabba with modern designs.",
      "detailTitle": "LUALUAH 1",
      "detailDescription": "Situated in Al Murabba with modern designs."
    },
    "lualuah5": {
      "title": "LUALUAH 5",
      "projectDescription": "Designed today to inspire tomorrow.",
      "detailTitle": "LUALUAH 5",
      "detailDescription": "King Fahd Road, designed today to inspire tomorrow."
    },
    "lualuah6": {
      "title": "LUALUAH 6",
      "projectDescription": "Future innovation hub for creative projects.",
      "detailTitle": "LUALUAH 6",
      "detailDescription": "Future innovation hub for creative projects."
    }
  },

  "specs": {
    "district": "District",
    "buildings": "Buildings",
    "noOfFloors": "No. of Floors",
    "buildingArea": "Building Area",
    "totalSurfaceArea": "Total Surface Area",
    "units": "Units",
    "totalArea": "Total Area",
    "values": {
      "almAlaz": "ALMALAZ",
      "alMurabba": "AL MURABBA"
    }
  },
///////////////////////////////////////////////

  "asset_management": {
    "title": "Asset Management",
    "asset_count": "Number of assets",
    "locations": "Riyadh and Other Cities",
    "asset_types": "Type of Assets",
    "final_value": "Final Value",
    "total_area": "Total Rentable Area"
  },
  "asset": {
    "parking": "PARKING",
    "wedding_halls": "WEDDING HALLS",
    "residential_villas": "RESIDENTIAL VILLAS",
    "trade_fairs": "TRADE FAIRS",
    "schools": "SCHOOLS",
    "custody_division": "CUSTODY DIVISION",
    "offices": "OFFICES",
    "shopping_mall": "SHOPPING MALL"
  },


////////////////////////////////////////////////

 "header": "LULUAT ALOMRAN PRESENCE",
      "developingProjects": "Luluat Al Omran is actively developing its projects in:",
      "locations": [
        "Riyadh",
        "Dammam",
        "Makkah",
        "Al-Jouf",
        "Sakaka",
        "Hafar Al-Batin",
        "Madinah",
        "Najran"
      ],
      "futureVision": "With a forward-looking vision to expand into the rest of the Kingdom’s cities in the near future.",




//////////////////////////////////////////////////
"orgStructure": {
    "title": "ORGANIZATIONAL STRUCTURE",
    "boardOfDirectors": "BOARD OF DIRECTORS",
    "executiveManagement": "EXECUTIVE MANAGEMENT",
    "chairman": {
      "name": "Eng. Sulaiman Al-Rejayae",
      "role": "Founder & Chairman"
    },
    "ceo": {
      "name": "Mr. Amer Al-Rejayae",
      "role": "Vice Chairman & CEO"
    },
    "roles": {
      "executiveDirector": "Executive Director",
      "nonExecutiveDirector": "Non-Executive Director",
      "independentDirector": "Independent Director",
      "advisoryMember": "Advisory Member",
      "gm": "General Manager / GM",
      "cfo": "Chief Financial Officer / CFO",
      "coo": "Chief Operating Officer / COO",
      "cmo": "Chief Marketing Officer / CMO"
    }
  },










    }
  },
  ar: {
    translation: {
     
"menu": {
    "open": "افتح القائمة",
    "close": "أغلق القائمة"
  },
  "nav": {
    "home": "الرئيسية",
    "projects": "المشاريع",
    "services": "الخدمات",
    "about": "من نحن"
  },
  //////////////////////////////////////////////////////////////

  "slides": [
    {
      "title": "الإرث",
      "description": "نحن لا نبني هياكل فقط — بل نبني إرثًا. كل مشروع ننجزه هو وعد بالمتانة والجمال والهدف، مصمم ليبقى ويُلهم المستقبل."
    },
    {
      "title": "التميّز",
      "description": "الجودة ليست تنازلاً — إنها أساسنا. من الفكرة إلى الإنجاز، كل خطوة مدفوعة بالدقة والحرفية والالتزام بتجاوز التوقعات."
    },
    {
      "title": "الابتكار",
      "description": "في عالم سريع التغير، البقاء في الصدارة يعني البناء بذكاء. ندمج التقنية الحديثة والتخطيط الذكي لنقدم حلولًا إنشائية فعّالة وجاهزة للمستقبل."
    },
    {
      "title": "الرؤية",
      "description": "نحن لا نبني مباني فقط — بل نُحقق رؤى مستقبلية. باستخدام التصاميم المبتكرة والمواد المتقدمة والممارسات المستدامة، نحول الأفكار إلى معالم تدوم لأجيال."
    }
  ],
  "group": "مجموعة الإنشاءات",
//////////////////////////////////////////////////
 "about": {
    "alt": "عن فريقنا",
    "title": "لولوات العمران للتطوير العقاري — جذورها في التراث، وبناؤها للمستقبل",
    "intro": "لولوات العمران هو الفرع المتخصص في العقارات لشركة المنصورية للمقاولات العامة، شركة سعودية معروفة بخبرة تزيد عن 40 عاماً.",
    "detail1": "نفذت المنصورية أكثر من 750 مشروعاً في جميع أنحاء المملكة، تشمل المرافق الصحية، المؤسسات التعليمية، المباني الحكومية، المجمعات التجارية، وأكثر.",
    "detail2": "استناداً إلى هذا الأساس القوي، تأسست لولوات العمران لتقود الطريق في تطوير العقارات الحديثة والمبتكرة والمستدامة، لتلبية الاحتياجات المتطورة للسوق السعودي.",
    "detail3": "اليوم: تواصل لولوات العمران تشكيل المجتمعات الحضرية المتكاملة، مستندة إلى إرث المنصورية مع تقديم حلول عقارية مبتكرة وعالية القيمة تعزز جودة الحياة وتقدم عوائد قوية.",
    "readMore": "اقرأ المزيد",
    "readLess": "اقرأ أقل",
       "showMore": "اقرأ المزيد",
    "showLess": "إظهار أقل",
  },
  ///////////////////////////////////////////////////////////
   "partnerSlider": {
    "heading": "شركاء النجاح"
  },
//////////////////////////////////////////////////
  "services": {
    "title": "خدماتنا",
    "learnMore": "تعرف أكثر",
    "development": {
      "title": "تطوير العقارات",
      "description": "تطوير عقاري شامل لإنشاء عقارات مستدامة ومبتكرة."
    },
    "management": {
      "title": "إدارة وتأجير العقارات",
      "description": "خدمات إدارة وتأجير فعالة لتعظيم قيمة الأصول."
    },
    "construction": {
      "title": "إدارة البناء",
      "description": "إشراف خبير على مشاريع البناء لضمان الجودة والتسليم في الوقت المحدد."
    }
  },

/////////////////////////////////
 contactUs: "اتصل بنا",
        address: "العنوان",
        email: "البريد الإلكتروني",
        phone: "الهاتف",
        addressContent: "شركة لؤلؤة العمران العقارية، حي المربع، الرياض، المملكة العربية السعودية",
        emailAddress: "amer.alrejaye@luluatalomran.com",
        phoneNumbers: "+٩٦٦ ٥٥ ٥٤٧ ٣٤٦٣ \n +٩٦٦ ١١ ٤٨٨ ٧٤٩١",
        googleMapAlt: "خريطة جوجل",

///////////////////////////////
 heroTitleLine1: "ابنِ المستقبل",
    heroTitleLine2: "وعش اليوم",
    ourServices: "خدماتنا",
    stats: {
      districts: "الأحياء المغطاة",
      projects: "المشاريع قيد التطوير",
      units: "الوحدات قيد التطوير"

 },
///////////////////////////////////////////////////////
 "header": "حضور لؤلؤة العمران",
      "developingProjects": "لؤلؤة العمران تطور مشاريعها بنشاط في:",
      "locations": [
        "الرياض",
        "الدمام",
        "مكة",
        "الجوف",
        "سكاكا",
        "حفر الباطن",
        "المدينة المنورة",
        "نجران"
      ],
      "futureVision": "برؤية مستقبلية للتوسع في بقية مدن المملكة في القريب العاجل.",

/////////////////////////////////////////////////////
"team": {
    "heading": "أعضاء مجلس الإدارة",
    "members": [
      {
        "name": "م. سليمان الرجيعي",
        "role": "رئيس مجلس الإدارة"
      },
      {
        "name": "الأستاذ عامر الرجيعي",
        "role": "نائب الرئيس والرئيس التنفيذي"
      },
      {
        "name": "عمر الجاسم",
        "role": "عضو مجلس الإدارة"
      },
      {
        "name": "محمد بن مالك الأحمد",
        "role": "عضو مجلس الإدارة"
      },
      {
        "name": "عبدالسلام علي الأجلاّن",
        "role": "عضو مجلس الإدارة"
      }
    ]
  },
///////////////////////////////////////////
"projects": {
    "title": "مشاريعي",
    "area": "المساحة",
    "location": "الموقع",
    "projectsList": [
      {
        "name": "لؤلؤة 3",
        "description": "قيد التطوير",
        "area": "12,600 م²",
        "location": "الملز"
      },
      {
        "name": "لؤلؤة 2",
        "description": "قيد التطوير",
        "area": "15,000 م²",
        "location": "المربع"
      },
      {
        "name": "لؤلؤة 1",
        "description": "قيد التطوير",
        "area": "13,000 م²",
        "location": "المربع"
      },
      {
        "name": "لؤلؤة 4",
        "description": "قيد التطوير",
        "area": "81,000 م²",
        "location": "المربع"
      },
      {
        "name": "لؤلؤة العارض",
        "description": "قيد التطوير",
        "area": "135,450 م²",
        "location": "العارض"
      },
      {
        "name": "لؤلؤة 5",
        "description": "شقة حديثة في المدينة بإطلالات خلابة.",
        "area": "",
        "location": "طريق الملك فهد"
      },
      {
        "name": "لؤلؤة 6",
        "description": "شقة حديثة في المدينة بإطلالات خلابة.",
        "area": "",
        "location": "طريق الملك فهد"
      }
    ]
  },
/////////////////////////////////////////////////////////


"asset_management": {
    "title": "إدارة الأصول",
    "asset_count": "عدد الأصول",
    "locations": "الرياض ومدن أخرى",
    "asset_types": "أنواع الأصول",
    "final_value": "القيمة النهائية",
    "total_area": "إجمالي المساحة القابلة للتأجير"
  },
  "asset": {
    "parking": "مواقف السيارات",
    "wedding_halls": "قاعات الأفراح",
    "residential_villas": "فلل سكنية",
    "trade_fairs": "المعارض التجارية",
    "schools": "المدارس",
    "custody_division": "قسم الحضانة",
    "offices": "المكاتب",
    "shopping_mall": "المجمعات التجارية"
  },


////////////////////////////////////////////////////////



"history": {
    "title": "التاريخ",
    "subtitle": "لؤلؤة العمران لتطوير العقارات – متجذرة في الإرث، مبنية للمستقبل.",
    "paragraph1": "لؤلؤة العمران هي الذراع المتخصصة في العقارات لشركة المنصورية للمقاولات العامة، وهي شركة سعودية معروفة تتمتع بأكثر من 40 عامًا من الخبرة. نفذت المنصورية أكثر من 750 مشروعًا عبر المملكة، تشمل المرافق الصحية، المؤسسات التعليمية، المباني الحكومية، المجمعات التجارية، وأكثر من ذلك.",
    "paragraph2": "استنادًا إلى هذا الأساس القوي، تأسست لؤلؤة العمران لقيادة الطريق في التطوير العقاري الحديث والمبتكر والمستدام، لتلبية الاحتياجات المتطورة للسوق السعودي."
  },
  "milestones": {
    "title": "الإنجازات",
    "alMansouriyah": "شركة المنصورية للمقاولات العامة المحدودة",
    "industrial": "الصناعية",
    "turath": "تراث",
    "realEstateManagement": "إدارة العقارات",
    "medicalOffice": "المكتب الطبي",
    "medicalEngineering": "الهندسة الطبية",
    "raeal": "رائل",
    "luluatAlOmran": "شركة لؤلؤة العمران لتطوير العقارات"
  },
  "today": {
    "title": "اليوم:",
    "description": "تواصل لؤلؤة العمران تشكيل المجتمعات الحضرية المتكاملة، مستندة إلى إرث المنصورية مع تقديم حلول عقارية مبتكرة وذات قيمة عالية تعزز جودة الحياة وتوفر عوائد قوية."
  },
/////////////////////////////////////////
"hero": {
    "title": "نبني الأحلام، ونخلق المعالم",
    "subtitle": "مستقبلك يبدأ هنا",
    "button": "استكشاف المشاريع"
  },
//////////////////////////////////////////

 "ourProjects": "مشاريعنا",
  "seeMore": "المزيد",
  "seeAll": "عرض الكل",
  
  "topics": {
    "underDevelopment": "تحت التطوير",
    "futureProject": "مشروع مستقبلي"
  },

  "projects1": {
    "lualuah3": {
      "title": "لؤلؤة 3",
      "projectDescription": "مشروع مصمم لتلبية الاحتياجات الحديثة.",
      "detailTitle": "لؤلؤة 3",
      "detailDescription": "يقع في حي الملز، مصمم لاحتياجات العصر الحديث."
    },
    "lualuah2": {
      "title": "لؤلؤة 2",
      "projectDescription": "مشروع فاخر في حي المربع.",
      "detailTitle": "لؤلؤة 2",
      "detailDescription": "مشروع فاخر في حي المربع."
    },
    "lualuah1": {
      "title": "لؤلؤة 1",
      "projectDescription": "يقع في حي المربع بتصاميم حديثة.",
      "detailTitle": "لؤلؤة 1",
      "detailDescription": "يقع في حي المربع بتصاميم حديثة."
    },
    "lualuah5": {
      "title": "لؤلؤة 5",
      "projectDescription": "مصمم اليوم ليُلهم الغد.",
      "detailTitle": "لؤلؤة 5",
      "detailDescription": "طريق الملك فهد، مصمم اليوم ليُلهم الغد."
    },
    "lualuah6": {
      "title": "لؤلؤة 6",
      "projectDescription": "مركز ابتكار مستقبلي للمشاريع الإبداعية.",
      "detailTitle": "لؤلؤة 6",
      "detailDescription": "مركز ابتكار مستقبلي للمشاريع الإبداعية."
    }
  },

  "specs": {
    "district": "الحي",
    "buildings": "عدد المباني",
    "noOfFloors": "عدد الطوابق",
    "buildingArea": "مساحة المبنى",
    "totalSurfaceArea": "المساحة الكلية",
    "units": "الوحدات",
    "totalArea": "المساحة الكلية",
    "values": {
      "almAlaz": "الملز",
      "alMurabba": "المربع"
    }},
/////////////////////////////////////////
  followUs: "تابعنا",
    visionAlt: "شعار رؤية 2030",
    copyright:
      "© {{year}} شركة لؤلؤة العمران العقارية\nجميع الحقوق محفوظة.",

///////////////////////////////////

"services1": {
    "realEstate": {
      "title": "تطوير العقارات",
      "description": "مشروعات مبتكرة ومستدامة تشكل مستقبل العقارات. نحن نبني مجتمعات، لا مجرد مبانٍ."
    },
    "propertyManagement": {
      "title": "إدارة وتأجير العقارات",
      "description": "حقق أقصى عائد من الاستثمار مع خدمات التأجير والإدارة الشاملة. محل ثقة العملاء منذ سنوات."
    },
    "construction": {
      "title": "إدارة البناء",
      "description": "في الوقت المحدد، ضمن الميزانية، وبدقة عالية. يشرف خبراؤنا على كل مرحلة من التخطيط حتى التسليم."
    }
  },

//////////////////////////////////////////////////////
"orgStructure": {
    "title": "الهيكل التنظيمي",
    "boardOfDirectors": "مجلس الإدارة",
    "executiveManagement": "الإدارة التنفيذية",
    "chairman": {
      "name": "المهندس سليمان الرجيعي",
      "role": "المؤسس والرئيس"
    },
    "ceo": {
      "name": "السيد عامر الرجيعي",
      "role": "نائب الرئيس والرئيس التنفيذي"
    },
    "roles": {
      "executiveDirector": "المدير التنفيذي",
      "nonExecutiveDirector": "عضو مجلس إدارة غير تنفيذي",
      "independentDirector": "عضو مجلس إدارة مستقل",
      "advisoryMember": "عضو استشاري",
      "gm": "المدير العام",
      "cfo": "المدير المالي",
      "coo": "مدير العمليات",
      "cmo": "مدير التسويق"
    }
  },







    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // React already safes from XSS
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n;